import { Box, Skeleton, Grid, Card, Stack } from '@mui/material';
import { dashboardLayoutStyles } from '../layout/dashboardLayout.styles';

export const QuickStartSkeleton: React.FC = () => {
  return (
    <Box sx={dashboardLayoutStyles.quickStartGrid}>
      {[1, 2, 3].map((i) => (
        <Card
          key={i}
          sx={{
            padding: 3,
            borderRadius: 2,
            border: '1px solid var(--fx-surface-border, #E2E8F0)',
          }}
        >
          <Stack spacing={2}>
            <Skeleton variant="circular" width={48} height={48} />
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="100%" height={16} />
          </Stack>
        </Card>
      ))}
    </Box>
  );
};

export const ProjectGridSkeleton: React.FC = () => {
  return (
    <Grid container spacing={2}>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={200}
              sx={{
                backgroundColor: 'var(--fx-surface-muted, #F1F5F9)',
              }}
            />
            <Box sx={{ padding: 2 }}>
              <Stack spacing={1.5}>
                <Skeleton variant="text" width="80%" height={20} />
                <Skeleton variant="text" width="60%" height={16} />
                <Skeleton variant="text" width="70%" height={16} />
              </Stack>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export const ProjectListSkeleton: React.FC = () => {
  return (
    <Stack spacing={1}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Card
          key={i}
          sx={{
            padding: 2,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Skeleton variant="rectangular" width={60} height={60} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="30%" height={20} />
            <Skeleton variant="text" width="50%" height={16} sx={{ marginTop: 1 }} />
          </Box>
          <Skeleton variant="text" width={80} height={20} />
        </Card>
      ))}
    </Stack>
  );
};
